export var Size = {
  Sm: 'sm',
  Md: 'md',
  Lg: 'lg'
};